export default "__VITE_ASSET__06073ee9__"